import { Store } from 'react-notifications-component';

const defaultConfig = {
    insert: 'top',
    container: 'top-right',
    animationIn: ['notification-in'],
    animationOut: ['notification-out'],
    dismiss: {
        duration: 10000,
        onScreen: true,
        showIcon: true,
    }
}
export const Notify = {
    error(title, message, config = {}) {
        Store.addNotification({
            ...defaultConfig,
            title: title,
            message: message,
            type: 'danger',
            ...config,
        })
    },
    
    // info(title, message, config = {}) {
    //     Store.addNotification({
    //         ...defaultConfig,
    //         title: title,
    //         message: message,
    //         type: 'info',
    //         ...config,
    //     })
    // },
    
    
    success(title, message, config = {}) {
        Store.addNotification({
            ...defaultConfig,
            title: title,
            message: message,
            type: 'success',
            ...config,
        })
    }
};